import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import AidasCustomer from './aidas-customer';
import AidasCustomerDetail from './aidas-customer-detail';
import AidasCustomerUpdate from './aidas-customer-update';
import AidasCustomerDeleteDialog from './aidas-customer-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={AidasCustomerUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={AidasCustomerUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={AidasCustomerDetail} />
      <ErrorBoundaryRoute path={match.url} component={AidasCustomer} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={AidasCustomerDeleteDialog} />
  </>
);

export default Routes;
